<template>
<div style="background: #F6F6F6;padding-bottom: 30px;">
	<productHead></productHead>
	<div class="wrap">
	
		<router-view></router-view>
	</div>
</div>
</template>

<script>
import productHead from '../../components/productHead.vue'
export default{
	components:{
		 productHead,
	},
	name:'productService',
	data(){
		return{
			title:'',
			whereForm:"",
		}
	},
	beforeRouteEnter(to, from, next){
		next(vm=>{
			if(to.meta.keepAlive){
				vm.$store.commit( "ADD_CachePage", "productService")
			}
		})
	},
	beforeRouteUpdate(to,from,next) {
		if(to.meta.keepAlive){
			this.$store.commit( "ADD_CachePage", "productService")
		}
		next() 
	},
	beforeRouteLeave(to, from, next){
		if(!to.meta.editor){
			this.$store.commit('Del_CachePage')
		}
		next()
	},

}
</script>

<style scoped lang="less">

</style>